"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkmarkTheme = exports.checkboxMotionTheme = exports.checkboxLabelTheme = exports.checkboxColors = exports.checkboxBorderTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _colors = require("../../constants/colors");
const checkboxColors = (0, _sdsThemeInternal.themed)({
  check: {
    background: {
      rest: {
        unchecked: (0, _designTokensReact.color)("color--background--surfaces--body", _designTokens.lodestarColors.neutralLight40),
        checked: {
          "lodestar-light": _designTokens.lodestarColors.buttonPrimary,
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--background--primary--default", _designTokens.ursaColors.blue500)
        }
      },
      hover: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.neutralLight10),
          "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50)
        },
        checked: {
          "lodestar-light": _designTokens.lodestarColors.buttonPrimary,
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--background--primary--strong", _designTokens.ursaColors.blue600)
        }
      },
      active: {
        unchecked: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.neutralLight10),
        checked: {
          "lodestar-light": _designTokens.lodestarColors.buttonPrimary,
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--background--primary--stronger", _designTokens.ursaColors.blue700)
        }
      },
      disabled: {
        unchecked: (0, _designTokensReact.color)("color--background--surfaces--body", _designTokens.lodestarColors.neutralLight40),
        checked: {
          "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.buttonPrimary, 0.4),
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--icons--info--weak", _designTokens.ursaColors.blue200)
        }
      },
      invalid: {
        // Invalid bg styles are the same as valid bg styles.
        rest: {
          checked: {
            "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
            "ursa-light": (0, _designTokensReact.color)("color--background--destructive--strong", _designTokens.ursaColors.red500)
          }
        },
        hover: {
          checked: {
            "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
            "ursa-light": (0, _designTokensReact.color)("color--background--destructive--stronger", _designTokens.ursaColors.red600)
          }
        },
        active: {
          checked: {
            "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
            "ursa-light": (0, _designTokensReact.color)("color--background--destructive--strongest", _designTokens.ursaColors.red700)
          }
        }
      }
    },
    border: {
      rest: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong", _designTokens.lodestarColors.neutralAccessible),
          "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak", _designTokens.ursaColors.neutral200)
        },
        checked: "transparent"
      },
      hover: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong", _designTokens.lodestarColors.neutralAccessible),
          "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak", _designTokens.ursaColors.neutral200)
        },
        checked: "transparent"
      },
      active: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong", _designTokens.lodestarColors.neutralAccessible),
          "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak", _designTokens.ursaColors.neutral200)
        },
        checked: "transparent"
      },
      disabled: {
        unchecked: {
          "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.neutralAccessible, 0.4),
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.ursaColors.neutral75)
        },
        checked: "transparent"
      },
      invalid: {
        rest: {
          unchecked: {
            "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
            "ursa-light": (0, _designTokensReact.color)("color--background--destructive--strong", _designTokens.ursaColors.red500)
          },
          checked: "transparent"
        },
        hover: {
          unchecked: {
            "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
            "ursa-light": (0, _designTokensReact.color)("color--background--destructive--stronger", _designTokens.ursaColors.red600)
          },
          checked: "transparent"
        },
        active: {
          unchecked: {
            "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
            "ursa-light": (0, _designTokensReact.color)("color--background--destructive--strongest", _designTokens.ursaColors.red700)
          },
          checked: "transparent"
        }
      }
    },
    icon: {
      rest: {
        unchecked: (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
        checked: (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
        outline: "transparent"
      },
      active: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.ursaColors.neutral00)
        },
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.ursaColors.neutral00)
        }
      },
      hover: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
          "ursa-light": "transparent"
        },
        checked: {
          "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.neutralLight40, 0.6),
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.ursaColors.neutral00)
        }
      },
      disabled: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.ursaColors.neutral00)
        },
        outline: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral--weakest", _designTokens.ursaColors.neutral75)
        }
      },
      invalid: {
        rest: (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
        hover: (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
        active: (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40)
      }
    }
  },
  flag: {
    background: {
      rest: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      hover: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      active: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      disabled: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      invalid: {
        // Invalid bg styles are the same as valid bg styles.
        rest: {
          checked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          }
        },
        hover: {
          checked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          }
        },
        active: {
          checked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          }
        }
      }
    },
    border: {
      rest: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      hover: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      active: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      disabled: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      invalid: {
        rest: {
          unchecked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          },
          checked: "transparent"
        },
        hover: {
          unchecked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          },
          checked: "transparent"
        },
        active: {
          unchecked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          },
          checked: "transparent"
        }
      }
    },
    icon: {
      rest: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--destructive--strong", _designTokens.lodestarColors.visRedDark10),
          "ursa-light": _designTokens.ursaColors.orange400 //no token exists
        },

        outline: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--destructive--strong", _designTokens.lodestarColors.visRedDark10),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral--weaker", _designTokens.ursaColors.neutral200)
        }
      },
      active: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral--weakest", _designTokens.ursaColors.neutral75)
        },
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--destructive--strong", _designTokens.lodestarColors.visRedDark10),
          "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-orange--stronger", _designTokens.ursaColors.orange600)
        }
      },
      hover: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.neutralLight10),
          "ursa-light": (0, _designTokensReact.color)("color--text--neutral-inverse--weak", _designTokens.ursaColors.neutral50)
        },
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--destructive--strong", _designTokens.lodestarColors.visRedDark10),
          "ursa-light": (0, _designTokensReact.color)("color--background--notifications--default", _designTokens.ursaColors.orange500)
        }
      },
      disabled: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.neutralAccessible, 0.4),
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-orange--weak", _designTokens.ursaColors.orange200)
        },
        outline: {
          "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.neutralAccessible, 0.4),
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral--weakest", _designTokens.ursaColors.neutral75)
        }
      },
      invalid: {
        rest: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
          "ursa-light": (0, _designTokensReact.color)("color--icons--destructive--strong", _designTokens.ursaColors.red500)
        },
        hover: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
          "ursa-light": (0, _designTokensReact.color)("color--icons--destructive--stronger", _designTokens.ursaColors.red600)
        },
        active: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
          "ursa-light": (0, _designTokensReact.color)("color--background--destructive--strongest", _designTokens.ursaColors.red700)
        }
      }
    }
  },
  star: {
    background: {
      rest: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      hover: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      active: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      disabled: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        }
      },
      invalid: {
        // Invalid bg styles are the same as valid bg styles.
        rest: {
          checked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          }
        },
        hover: {
          checked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          }
        },
        active: {
          checked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          }
        }
      }
    },
    border: {
      rest: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      hover: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      active: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      disabled: {
        unchecked: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        checked: "transparent"
      },
      invalid: {
        rest: {
          unchecked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          },
          checked: "transparent"
        },
        hover: {
          unchecked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          },
          checked: "transparent"
        },
        active: {
          unchecked: {
            "lodestar-light": "transparent",
            "ursa-light": "transparent"
          },
          checked: "transparent"
        }
      }
    },
    icon: {
      rest: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--spectrum-yellow--default", _designTokens.lodestarColors.visYellow),
          "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-gold--strong", _designTokens.ursaColors.gold500)
        },
        outline: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--spectrum-yellow--default", _designTokens.lodestarColors.visYellow),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral--weaker", _designTokens.ursaColors.neutral200)
        }
      },
      active: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--icons--neutral-inverse--default", _designTokens.lodestarColors.neutralLight40),
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral--weakest", _designTokens.ursaColors.neutral75)
        },
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--spectrum-yellow--default", _designTokens.lodestarColors.visYellow),
          "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-gold--strongest", _designTokens.ursaColors.gold700)
        }
      },
      hover: {
        unchecked: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.neutralLight10),
          "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50)
        },
        checked: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--spectrum-yellow--default", _designTokens.lodestarColors.visYellow),
          "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-gold--stronger", _designTokens.ursaColors.gold600)
        }
      },
      disabled: {
        unchecked: "transparent",
        checked: {
          "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.neutralAccessible, 0.4),
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-gold--weaker", _designTokens.ursaColors.gold200)
        },
        outline: {
          "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.neutralAccessible, 0.4),
          //no token exists
          "ursa-light": (0, _designTokensReact.color)("color--icons--neutral--weakest", _designTokens.ursaColors.neutral75)
        }
      },
      invalid: {
        rest: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
          "ursa-light": (0, _designTokensReact.color)("color--background--destructive--strong", _designTokens.ursaColors.red500)
        },
        hover: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
          "ursa-light": (0, _designTokensReact.color)("color--icons--destructive--stronger", _designTokens.ursaColors.red600)
        },
        active: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--error--default", _designTokens.lodestarColors.buttonDestructive),
          "ursa-light": (0, _designTokensReact.color)("color--background--destructive--strongest", _designTokens.ursaColors.red700)
        }
      }
    }
  }
});
exports.checkboxColors = checkboxColors;
const checkboxBorderTheme = (0, _sdsThemeInternal.themed)({
  borderRadius: {
    16: {
      "lodestar-light": _designTokens.border.radius05,
      "ursa-light": _designTokens.border.radius10
    },
    20: {
      "lodestar-light": _designTokens.border.radius05,
      "ursa-light": _designTokens.border.radius20
    }
  }
});
exports.checkboxBorderTheme = checkboxBorderTheme;
const checkboxMotionTheme = (0, _sdsThemeInternal.themed)({
  background: {
    "lodestar-light": "",
    "ursa-light": `background-color ${_designTokens.motion.animation.default}, color ${_designTokens.motion.animation.default}`
  },
  flag: "",
  star: "",
  check: {
    "lodestar-light": "",
    "ursa-light": `stroke-dashoffset 4500ms ${_designTokens.motion.easing.default} 100ms`
  }
});
exports.checkboxMotionTheme = checkboxMotionTheme;
const checkboxLabelTheme = (0, _sdsThemeInternal.themed)({
  color: {
    rest: "inherit",
    disabled: {
      "lodestar-light": (0, _colors.toRgba)(_designTokens.lodestarColors.neutralDark40, 0.4),
      //no token exists
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--strongest", _designTokens.ursaColors.neutral300)
    }
  },
  gap: {
    "lodestar-light": "8px",
    "ursa-light": "6px"
  },
  fontWeight: {
    "lodestar-light": _designTokens.typography.fontWeight.regular,
    "ursa-light": _designTokens.typography.fontWeight.medium
  }
});
exports.checkboxLabelTheme = checkboxLabelTheme;
const checkmarkTheme = (0, _sdsThemeInternal.themed)({
  size: {
    16: {
      "lodestar-light": 16,
      // The icon in ursa is always 20px.
      "ursa-light": 20
    },
    20: {
      "lodestar-light": 20,
      "ursa-light": 20
    }
  }
});
exports.checkmarkTheme = checkmarkTheme;
//# sourceMappingURL=checkboxTheme.js.map